<template>
  <footer>
    <div class="container">
      <div class="footer-content">
        <!-- 第一行：左侧logo，右侧产品服务 -->
        <div class="top-row">
          <div class="imgBox">
            <img src="@/assets/image/logo.png" alt="嗨喵悦动,嗨喵互动,logo图标" srcset="">
          </div>
          <!-- 右侧：产品服务区域 -->
          <section class="info">
            <div class="product">
              <div class="tit">产品</div>
              <div class="item" @click="toDemo('0')">婚礼版</div>
              <div class="item" @click="toDemo('1')">年会版</div>
              <div class="item" @click="toDemo('2')">生日版</div>
            </div>
            <div class="service">
              <div class="tit">服务与支持</div>
              <div class="item">
                 <a href="/statement" target="_blank">法律声明</a>
              </div>
              <div class="item">
                 <a href="/partner" target="_blank">嗨喵合伙人</a>
              </div>
              <div class="item">
                 <a href="/join" target="_blank">加入我们</a>
              </div>
              <div class="item">
                 <a href="/advertisement" target="_blank">广告投放</a>
              </div>
            </div>
            <div class="company">
              <div class="tit">嗨喵悦动</div>
              <div class="item">
                 <a href="/company" target="_blank">公司简介</a>
              </div>
              <div class="item">
                 <a href="/service" target="_blank">用户协议</a>
              </div>
              <div class="item">
                 <a href="/introduce" target="_blank">产品介绍</a>
              </div>
              <div class="item">
                 <a href="/us" target="_blank">关于我们</a>
              </div>
            </div>
            <div class="contact">
              <div class="tit">联系我们</div>
              <div class="item">客服电话：19512368757 (00:00-24:00)</div>
            </div>
          </section>
        </div>

        <!-- 第二行：版权与备案信息 -->
        <section class="bottom-row">
          <section class="copyRight">
            <div class="cp">
              版权：©2015 hudongmiao.com . All rights reserved 嗨喵悦动
            </div>
            <div class="ICP">
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo/"
                style="
                  display: inline-block;
                  text-decoration: none;
                  height: 20px;
                  line-height: 20px;
                "
              >
                <img src="@/assets/image/jx.png" style="float: left" alt="嗨喵悦动,嗨喵互动,logo图标"/>
                <p
                  class="icp"
                >
                  沪公网安备 31010702006802号
                </p>
              </a>
              <a
                target="_blank"
                href="https://beian.miit.gov.cn/"
                style="
                  display: inline-block;
                  text-decoration: none;
                  height: 20px;
                  line-height: 20px;
                  margin-left: 20px;
                "
              >
                <p
                  class="icp"
                >
                  沪ICP备 2020028729号
                </p>
              </a>
            </div>
          </section>
        </section>
      </div>
    </div>
  </footer>
</template>

<script>
import { WEDDING, ENTERPRISE, BIRTH } from '@/assets/constant/default';

export default {
  name: 'myFooter',
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    toDemo(indexStr) {
      if (indexStr === '0') {
        window.open(WEDDING, '_blank');
      } else if (indexStr === '1') {
        window.open(ENTERPRISE, '_blank');
      } else if (indexStr === '2') {
        window.open(BIRTH, '_blank');
      }
    },
  },
};
</script>
<style lang="less" scoped>
footer {
  a {
    color: #83838b;
    &:hover {
      color: #fc9632;
    }
  }

  .footer-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    align-items: stretch;
    justify-content: flex-start;
  }

  .top-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-left: 125px;
  }

  .imgBox {
    margin-bottom: 0;
    img {
      width: 253px;
      height: 120px;
    }
  }

  .bottom-row {
    margin-top: 40px;
    margin-left: 125px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .copyRight {
    .cp {
      font-size: 14px;
      font-weight: 500;
      color: #F7A121;
      text-align: center;
      margin-bottom: 20px;
    }
    .ICP {
      text-align: left;
        .icp {
          float: left;
          font-size: 14px;
          height: 20px;
          line-height: 20px;
          margin: 0px 0px 0px 5px;
          color: #939393;
        }
    }
  }

  .info {
    margin-right:50px;
    display: flex;
    gap: 90px;
    justify-content: space-between;

    .product {
      .tit {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 9px;
      }
      .item {
        font-size: 14px;
        font-weight: 400;
        margin-top: 9px;
        color: #83838b;
        cursor: pointer;
        &:hover {
          color: #fc9632;
        }
      }
    }
    .service {
      .tit {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 9px;
      }
      .item {
        font-size: 14px;
        font-weight: 400;
        margin-top: 9px;
        color: #83838b;
        cursor: pointer;
        &:hover {
          color: #fc9632;
        }
      }
    }
    .company {
      .tit {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 9px;
      }
      .item {
        font-size: 14px;
        font-weight: 400;
        margin-top: 9px;
        color: #83838b;
        cursor: pointer;
        &:hover {
          color: #fc9632;
        }
      }
    }
    .contact {
      .tit {
        font-size: 18px;
        font-weight: 600;
        color: #000;
        margin-bottom: 9px;
      }
      .item {
        font-size: 14px;
        font-weight: 400;
        margin-top: 9px;
        color: #83838b;
        cursor: pointer;
      }
    }
  }
}
</style>
